export default __webpack_public_path__ + "static/noi2019daniel2-19f759ddc95bd5df2a07f1662f3af685.jpg";